module.exports = __webpack_public_path__ + "static/media/chieraToniolo1.28e23068.jpg";